import { AiAssistantButton } from '@elva/ai-chat';
import React from 'react';
import { IconButton } from '../IconButton/IconButton';

export interface TriageTopBarActionsProps {
  onRefresh?: () => void;
  onBell?: () => void;
}

/** Live + bell + refresh — Triage header actions. */
export function TriageTopBarActions({ onRefresh, onBell }: TriageTopBarActionsProps) {
  return (
    <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
      <span className="inline-flex h-8 items-center gap-1.5 rounded-[var(--r-pill)] bg-[var(--ai-tint)] px-[11px]">
        <span className="cal-live" />
        <span className="text-[11.5px] font-semibold text-[var(--ai-3)]">Live</span>
        <span className="font-[var(--font-mono)] text-[11px] text-[var(--ink-3)]">now</span>
      </span>
      <IconButton icon="bell" size={32} onClick={onBell} label="Notifications" />
      <IconButton icon="refresh" size={32} onClick={onRefresh} label="Refresh" />
      <AiAssistantButton />
    </div>
  );
}
